<script setup lang="ts">
import SidebarWrapper from '@/components/SidebarWrapper.vue';
import { useRoute } from 'vue-router';
import { useValhallaStore } from '@/store/valhallaStore';
import { computed, h } from 'vue';
import { Toaster } from 'vue-sonner';
import { CircleCheck, Info, TriangleAlert, OctagonX, Loader2 } from 'lucide-vue-next';

const route = useRoute();
useValhallaStore(); // Not used directly here, but we need to ensure that the websocket connection is established

const showSidebar = computed(() => route.meta.sidebar === true);

const sonnerIcons = {
  success: h(CircleCheck, { class: 'size-4' }),
  info: h(Info, { class: 'size-4' }),
  warning: h(TriangleAlert, { class: 'size-4' }),
  error: h(OctagonX, { class: 'size-4' }),
  loading: h(Loader2, { class: 'size-4 animate-spin' }),
};
</script>

<template>
  <SidebarWrapper v-if="showSidebar">
    <RouterView />
  </SidebarWrapper>
  <RouterView v-else />
  <Toaster position="bottom-right" richColors theme="system" :icons="sonnerIcons" :close-button="true" />
</template>

<style>
@import 'vue-sonner/style.css';
</style>
